import { render, staticRenderFns } from "./startpageModernItem.vue?vue&type=template&id=0bf791e5"
import script from "./startpageModernItem.vue?vue&type=script&lang=js"
export * from "./startpageModernItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports